import React from "react";
import { useTranslation } from "react-i18next";

import { UseCases } from "@planzone/core";
import { useModal } from "@root/client/modal";
import { Props } from "./types";
import { Safeguard } from "@scenes/safeguard";
import styles from "./styles.scss";

function Menu({ project }: Props) {
  const { t } = useTranslation();
  const { pushView } = useModal();

  return (
    <Safeguard useCases={[UseCases.addPlanzoneResourceToProject]}>
      {({ canAddPlanzoneResourceToProject }) =>
        canAddPlanzoneResourceToProject && (
          <div className={styles.menu}>
            <button
              className={styles.addResourceButton}
              onClick={() =>
                pushView({
                  data: project,
                  key: UseCases.addPlanzoneResourceToProject,
                })
              }
            >
              <div className={styles.iconBox}>+</div>
              <p>{t("projectResourcesPage.addResource")}</p>
            </button>
          </div>
        )
      }
    </Safeguard>
  );
}

export { Menu };
